module.exports = __webpack_public_path__ + "img/10_96.1f1555e8.png";